"use strict";var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;exports.__esModule = true;exports.LightTheme5_5 = void 0;var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));var _ThemeHelpers = require("../../lib/theming/ThemeHelpers");

var _BasicTheme = require("./BasicTheme");
var _LightTheme5_2 = require("./LightTheme5_4");var _LightTheme5_;

var LightTheme5_5 = exports.LightTheme5_5 = (0, _ThemeHelpers.createTheme)({
  themeClass: (_LightTheme5_ = /*#__PURE__*/function (_BasicThemeClassForEx) {function LightTheme5_5() {return _BasicThemeClassForEx.apply(this, arguments) || this;}(0, _inheritsLoose2.default)(LightTheme5_5, _BasicThemeClassForEx);return (0, _createClass2.default)(LightTheme5_5, null, [{ key: "fileUploaderBorderColor", get:





      function get() {
        return this.borderColorGrayLight;
      } }, { key: "fileUploaderDisabledTextColor", get:



      function get() {
        return this.fileUploaderDisabledColor;
      } }, { key: "fileUploaderDisabledFileTypeIcon", get:
      function get() {
        return this.fileUploaderDisabledIconColor;
      }
      //#endregion FileUploader
    }]);}(_BasicTheme.BasicThemeClassForExtension), _LightTheme5_.fileUploaderPaddingXSmall = '7px', _LightTheme5_.fileUploaderPaddingXMedium = '9px', _LightTheme5_.fileUploaderPaddingXLarge = '11px', _LightTheme5_.fileUploaderDisabledColor = 'rgba(0, 0, 0, 0.54)', _LightTheme5_.fileUploaderDisabledIconColor = 'rgba(0, 0, 0, 0.32)', _LightTheme5_),
  prototypeTheme: _LightTheme5_2.LightTheme5_4,
  themeMarkers: [(0, _ThemeHelpers.markThemeVersion)('5.5')]
});